module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai301-c0e71bc8a7b22276bd1e17ee92aced44.jpg";